import { Component, Input } from "@angular/core";

@Component({
    selector: "m-diagnosis-badge",
    template: `
        <p-badge *ngIf="isOSIICSCode" severity="success" value="O"> </p-badge>
        <p-badge *ngIf="isOSIICSCode === false" severity="info" value="S"> </p-badge>
    `,
   styleUrls: ["./diagnosis-badge.component.scss"]
})
export class DiagnosisBadgeComponent {
    @Input() isOSIICSCode: boolean;
}
